export default __webpack_public_path__ + "static/media/039-tools-and-utensils.3927fec9.png";